var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('tiptap-menu-bar',{staticClass:"grey-border-bottom",attrs:{"editor":_vm.editor}}),_c('editor-content',{staticClass:"editor__content",attrs:{"editor":_vm.editor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }